import { CheckArrayMatchesUnion } from './checkArrayMatchesUnion'
import { ButtonProps } from './interfaces'

const BUTTON_OWN_PROPS = [
  'ariaLabel',
  'tabIndex',
  'buttonType',
  'onClick',
  'buttonClassName',
] as const

export const SafeButtonOwnProps: CheckArrayMatchesUnion<
  typeof BUTTON_OWN_PROPS,
  keyof ButtonProps
> = BUTTON_OWN_PROPS

const LINK_OWN_PROPS = [
  'ariaLabel',
  'tabIndex',
  'to',
  'href',
  'target',
  'rel',
  'linkAs',
  'onClick',
] as const

export const SafeLinkOwnProps: CheckArrayMatchesUnion<
  typeof LINK_OWN_PROPS,
  typeof LINK_OWN_PROPS[number]
> = LINK_OWN_PROPS

const RADIO_OWN_PROPS = ['value', 'showControl', 'disabled', 'invalid'] as const

export const SafeRadioOwnProps: CheckArrayMatchesUnion<
  typeof RADIO_OWN_PROPS,
  typeof RADIO_OWN_PROPS[number]
> = RADIO_OWN_PROPS
